import React, { PropTypes } from 'react'
import { Manager, Target, Popper, Arrow } from 'react-popper'
import Action from './Action'
import cx from 'classnames'
import { Button, Icon } from '@blueprintjs/core'
import { EDIT_MODE } from './constants'
import { connect } from 'react-redux'

function injectAction(onClick) {
  function BoundAction({text, mode}) {
    return <Action text={text} onClick={()=>onClick(mode)}/>
  }
  BoundAction.propTypes = {
    text: PropTypes.string.isRequired,
    mode: PropTypes.string.isRequired,
  }
  return BoundAction
}

class Table extends React.Component {
  constructor(props){
    super(props)
    this.toggle = this.toggle.bind(this)
    this.handleActionClick = this.handleActionClick.bind(this)
    this.state = {
      active: null
    }
  }
  toggle(active){
    this.setState({active})
  }
  handleActionClick(target, mode){
    this.props.setAction({target, mode})
    this.setState({active: null})
  }
  render(){
    let { departments, stores, storeId } = this.props
    let { active } = this.state
    return (
      <div>
        <table className="pt-table pt-striped pt-interactive" width="100%">
          <thead>
            <tr>
              <th>Name</th>
              <th>Printer</th>
              <th>Workflow</th>
              <th/>
            </tr>
          </thead>
          <tbody>
            {departments.map((kd)=>{
              const Action = injectAction(this.handleActionClick.bind(this, kd))
              let store = stores.find(({id})=>id!=storeId&&id==kd.store_id)
              return (
                <tr key={kd.id}>
                  <td>
                    <div className="kd-name-wrapper">
                      <div className="kd-name">{kd.name}</div>
                      {store?<div className="kd-store-name">Created at: {store.title}</div>:null}
                    </div>
                  </td>
                  <td>{kd.printers.map(({name})=>name).join(',')||'Null'}</td>
                  <td>{kd.workflow?kd.workflow.name:'Null'}</td>
                  <td width="10%">
                    <Manager className="kd-actions-wrapper">
                      <Target>
                        <Button text="Action" rightIconName="caret-down" onClick={()=>this.toggle(kd)}/>
                      </Target>
                      {active===kd?(
                        <Popper placement="bottom" className="popper">
                          <Action text="Edit" mode={EDIT_MODE.EDIT}/>
                          <Action text="Assign Printer" mode={EDIT_MODE.ASSIGN_PRINTER}/>
                          <Action text="Set Workflow" mode={EDIT_MODE.SET_WORKFLOW}/>
                          <Action text="Remove" mode={EDIT_MODE.REMOVE}/>
                          <Arrow className="popper__arrow">
                            <Icon iconName="caret-up"/>
                          </Arrow>
                        </Popper>
                      ):null}
                    </Manager>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
        <div className={cx('kd-screen', {active})} onClick={()=>this.toggle(null)}/>
      </div>
    )
  }
}

Table.propTypes = {
  setAction: PropTypes.func.isRequired,
  departments: PropTypes.array.isRequired,
  stores: PropTypes.array.isRequired,
  storeId: PropTypes.string.isRequired,
}

function mapStateToProps({stores}, props) {
  return {
    ...props,
    stores,
  }
}

export default connect(mapStateToProps)(Table)



/** WEBPACK FOOTER **
 ** ./client/pages/kitchen-department/Table.js
 **/